import { SVGIconComponent } from './types';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';

export const ActionEnable: SVGIconComponent = ({ className, color, style }) => (
  <CheckCircleOutlinedIcon
    style={{
      color: color ?? '#848484',
      fontSize: '24px',
      ...style
    }}
    className={className}
  ></CheckCircleOutlinedIcon>
);
